import { ref } from "vue";

export const useHandleScrollPosition = () => {
  const currentScrollTop = ref<number>(0);

  const setCurrentScrollTop = (element?: HTMLElement) => {
    if (!element) return;
    currentScrollTop.value = element.scrollTop;
  };

  const moveToCurrentScrollTop = (element?: HTMLElement) => {
    if (!element) return;
    element.scrollTo({ top: currentScrollTop.value });
  };

  return { setCurrentScrollTop, moveToCurrentScrollTop };
};
